import { z } from 'zod';

// the one error shape every endpoint returns
export const ErrorCode = z.enum([
  'bad_request',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'internal',
  // the admin must set up, or enter, a two-step login code before continuing
  'two_step_setup_required',
  'two_step_required',
  // the player must finish their profile (username, date of birth, legal documents) first
  'profile_required',
  // the account is suspended or banned (details.hold says which, until when, and why)
  'account_held',
  // the date of birth given shows the player is under 18; the account stays blocked until support reviews it
  'age_restricted',
  // money: the account cannot cover the amount, is frozen while support investigates, or the same
  // idempotency key was sent again with a different request
  'insufficient_funds',
  'account_frozen',
  'idempotency_conflict',
]);
export type ErrorCode = z.infer<typeof ErrorCode>;
export const ApiError = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;
